import React from 'react';
import { NavLink, NavLinkProps } from 'react-router-dom';

import * as Types from 'types';

type Props = {
  to: string;
  isActive?: NavLinkProps['isActive'];
  title: string;
};

export const VaultNavigationItem = (props: Props) => (
  <NavLink
    className='vault-navigation__item mr-1 mr-sm-2'
    to={props.to}
    isActive={props.isActive}
    activeClassName='vault-navigation__item--active'
  >
    {props.title}
  </NavLink>
);
